module.exports = __webpack_public_path__ + "static/MG-723f66396ddea211cd46c5fddbdfbb06.jpg";